const WindowType={PLOT_DETAILED_INFORMATION:'plotDetailedInformation',
	PLOTS_SELECTION_MENU:'plotsSelectionMenu',
	HOUSE_TYPE_VIEWER:'houseTypeViewer',
	SITE_PLAN:'sitePlan'};
export default WindowType;		